import React, { useMemo, useState, useEffect } from "react";
import { Menu } from "antd";
import {
  ShopFilled,
  SettingFilled,
  TagFilled,
  WalletFilled,
  IdcardFilled,
  ContainerFilled,
  ReadFilled,
  DashboardFilled,
  ProfileFilled
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import { useTranslation } from "react-i18next";
import styles from "./index.module.less";
import { observer } from "mobx-react";
const firstMenu = {
  ShopFilled: <ShopFilled />,
  SettingFilled: <SettingFilled />,
  TagFilled: <TagFilled />,
  AccountBookFilled: <WalletFilled />,
  IdcardFilled: <IdcardFilled />,
  ContainerFilled: <ContainerFilled />,
  ReadFilled: <ReadFilled />,
  DashboardFilled: <DashboardFilled />,
  ProfileFilled: <ProfileFilled/>
};
export default withRouter(
  observer((props) => {
    const {
      location: { pathname },
      routes,
    } = props;
    const [OpenKeys, setOpenKeys] = useState([]); // 展开的菜单Key
    const [SelectedKeys, setSelectedKeys] = useState([]); // 选中的菜单
    const { t } = useTranslation();
  
    /**
     * @description: 渲染菜单
     * @param {type} params
     * @return {type}
     */
  
    const renderSubMenu = ({
      showSider,
      component,
      path,
      iconClassName,
      title,
      name,
      children,
      disabled,
    }) => {
      const { SubMenu } = Menu;
  
      if (!showSider) {
        // 是否显示在菜单中 、权限控制等
        return null;
      }
      const icon = firstMenu[iconClassName] ? (
        firstMenu[iconClassName]
      ) : ''
      // (
      //   <span className={`iconfont ${iconClassName}`} />
      // ); // 菜单图标
      if (component) {
        return (
          <Menu.Item key={path} icon={icon} disabled={disabled}>
            <Link className="single-link" to={path}>
              {name ? t(name) : t(title)}
            </Link>
          </Menu.Item>
        );
      }
      // 递归子菜单
      else if (children?.length) {
        return (
          <SubMenu key={path} title={name ? t(name) : t(title)} icon={icon} disabled={disabled}>
            {children.map((subRoute) => renderSubMenu(subRoute))}
          </SubMenu>
        );
      }
    };
    const menuItem = useMemo(() => {
      return routes?.map((subMenu) => renderSubMenu(subMenu));
    }, [routes, renderSubMenu]);

    const openMenu = () => {
      console.log(OpenKeys, 'OpenKeys')
      routes.forEach((td) => {
        const { path, children } = td;
        if (children?.length > 0) {
          const isFind = children.find((ts) => ts.path === pathname);
          if (isFind) {
            setOpenKeys([path]);
            return;
          }
        }
      });
    }
    useEffect(() => {
      if (SelectedKeys?.length === 0) {
        setSelectedKeys([pathname]);
      }
      openMenu();
    }, [routes]);
    useEffect(() => {
      setSelectedKeys([pathname]);
      openMenu();
    }, [pathname])
    return (
      <Menu
        mode="inline"
        selectedKeys={SelectedKeys}
        openKeys={OpenKeys}
        onOpenChange={setOpenKeys}
        onSelect={({ selectedKeys }) => setSelectedKeys(selectedKeys)}
        className={styles.menu}
      >
        {menuItem}
      </Menu>
    );
  })
)

